import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PublishIcon from '@material-ui/icons/Publish';

import { ContentInput, S3ObjectInput } from 'api';
import { AspectRatios } from 'types/app';
import { UploadDialog, Uploader, UploadInput } from 'components';

const THUMBNAIL_SIZE = 72;

const useStyles = makeStyles({
  uploadButton: {
    width: THUMBNAIL_SIZE,
    height: THUMBNAIL_SIZE,
  },
  uploadButtonLabel: {
    flexDirection: 'column',
  },
});

const PhotoUpload: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext<ContentInput>();

  function handleSavePhoto(s3Object: S3ObjectInput) {
    setFieldValue('content_object.photos', [s3Object]);
  }

  return (
    <Uploader onSave={handleSavePhoto}>
      {uploaderProps => (
        <Fragment>
          <UploadInput onUpload={uploaderProps.onUpload}>
            <Button
              component="span"
              classes={{ root: classes.uploadButton, label: classes.uploadButtonLabel }}
            >
              <PublishIcon />
              <Typography variant="caption">{t('posting:upload')}</Typography>
            </Button>
          </UploadInput>
          <UploadDialog
            aspectRatio={AspectRatios.none}
            i18nKeyTitle="posting:photo"
            i18nKeyReplace="components:replaceImage"
            {...uploaderProps}
          />
        </Fragment>
      )}
    </Uploader>
  );
};

export default PhotoUpload;
